import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelText as _vModelText, vModelRadio as _vModelRadio, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-ac45e0ae")

_pushScopeId("data-v-ac45e0ae")
const _hoisted_1 = {
  class: "row",
  ref: "templateBody"
}
const _hoisted_2 = { class: "col-lg-12" }
const _hoisted_3 = { class: "nav nav-pills nav-fill" }
const _hoisted_4 = { class: "nav-item" }
const _hoisted_5 = { class: "nav-item" }
const _hoisted_6 = {
  class: "card-body",
  ref: "radiationPage"
}
const _hoisted_7 = /*#__PURE__*/_createVNode("svg", { class: "c-icon" }, [
  /*#__PURE__*/_createVNode("use", { "xlink:href": "/assets/icons/sprites/free.svg#cil-plus" })
], -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 방사능 추가 ")
const _hoisted_9 = {
  class: "form-horizontal",
  action: "",
  method: "post"
}
const _hoisted_10 = { class: "form-group row" }
const _hoisted_11 = { class: "col-md-1" }
const _hoisted_12 = /*#__PURE__*/_createVNode("label", null, "검출여부", -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("option", { value: null }, "전체", -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("option", { value: true }, "Yes", -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("option", { value: false }, "No", -1)
const _hoisted_16 = { class: "col-md-2" }
const _hoisted_17 = { class: "table table-responsive-sm table-bordered table-striped table-sm" }
const _hoisted_18 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", { class: "text-center" }, [
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "등록일자"),
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "분석일시"),
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "조사대상"),
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "어종"),
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "조사결과")
  ])
], -1)
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = {
  key: 0,
  class: "badge bg-danger text-white btn-sm"
}
const _hoisted_22 = {
  key: 1,
  class: "badge bg-success text-white btn-sm"
}
const _hoisted_23 = {
  key: 2,
  class: "badge bg-warning text-white btn-sm"
}
const _hoisted_24 = { class: "pagination justify-content-center" }
const _hoisted_25 = {
  class: "hide",
  ref: "shellfishPage"
}
const _hoisted_26 = {
  class: "card-body",
  ref: "shellfishPage"
}
const _hoisted_27 = /*#__PURE__*/_createVNode("svg", { class: "c-icon" }, [
  /*#__PURE__*/_createVNode("use", { "xlink:href": "/assets/icons/sprites/free.svg#cil-plus" })
], -1)
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" 패류독소 추가 ")
const _hoisted_29 = {
  class: "form-horizontal",
  action: "",
  method: "post"
}
const _hoisted_30 = { class: "form-group row" }
const _hoisted_31 = { class: "col-md-1" }
const _hoisted_32 = /*#__PURE__*/_createVNode("label", null, "검출여부", -1)
const _hoisted_33 = /*#__PURE__*/_createVNode("option", { value: null }, "All", -1)
const _hoisted_34 = /*#__PURE__*/_createVNode("option", { value: true }, "Yes", -1)
const _hoisted_35 = /*#__PURE__*/_createVNode("option", { value: false }, "No", -1)
const _hoisted_36 = { class: "col-md-2" }
const _hoisted_37 = { class: "table table-responsive-sm table-bordered table-striped table-sm" }
const _hoisted_38 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", { class: "text-center" }, [
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "등록일자"),
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "시료 채취일 및 기간"),
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "패류채취 금지해역")
  ])
], -1)
const _hoisted_39 = {
  key: 0,
  class: "badge bg-danger text-white btn-sm"
}
const _hoisted_40 = {
  key: 1,
  class: "badge bg-success text-white btn-sm"
}
const _hoisted_41 = { class: "pagination justify-content-center" }
const _hoisted_42 = {
  class: "modal-dialog modal-lg",
  role: "document"
}
const _hoisted_43 = { class: "modal-content" }
const _hoisted_44 = { class: "modal-header" }
const _hoisted_45 = /*#__PURE__*/_createVNode("h5", { class: "modal-title" }, "방사능", -1)
const _hoisted_46 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_47 = { class: "modal-body" }
const _hoisted_48 = { class: "table table-responsive-sm table-bordered table-sm" }
const _hoisted_49 = { colspan: "4" }
const _hoisted_50 = { class: "row justify-content-md-center align-items-center" }
const _hoisted_51 = /*#__PURE__*/_createVNode("div", { class: "col-2 text-center" }, " 수산물 방사능 ", -1)
const _hoisted_52 = /*#__PURE__*/_createVNode("div", { class: "col-2 text-center" }, " 분석일시 ", -1)
const _hoisted_53 = { class: "col-4" }
const _hoisted_54 = { class: "col-4" }
const _hoisted_55 = /*#__PURE__*/_createVNode("tr", null, [
  /*#__PURE__*/_createVNode("th", {
    colspan: "4",
    class: "text-center"
  }, " 조사대상 ")
], -1)
const _hoisted_56 = {
  colspan: "4",
  class: "text-center"
}
const _hoisted_57 = { class: "form-check form-check-inline" }
const _hoisted_58 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "target1"
}, " 국내산 ", -1)
const _hoisted_59 = { class: "form-check form-check-inline" }
const _hoisted_60 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "target2"
}, " 외국산 ", -1)
const _hoisted_61 = { class: "form-check form-check-inline" }
const _hoisted_62 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "target3"
}, " 국내산 & 외국산 ", -1)
const _hoisted_63 = /*#__PURE__*/_createVNode("tr", null, [
  /*#__PURE__*/_createVNode("th", {
    colspan: "4",
    class: "text-center"
  }, " 조사결과 ")
], -1)
const _hoisted_64 = {
  colspan: "4",
  class: "text-center"
}
const _hoisted_65 = { class: "form-check form-check-inline" }
const _hoisted_66 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "state1"
}, " 불검출 ", -1)
const _hoisted_67 = { class: "form-check form-check-inline" }
const _hoisted_68 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "state2"
}, " 미량검출 ", -1)
const _hoisted_69 = { class: "form-check form-check-inline" }
const _hoisted_70 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "state3"
}, " 검출 ", -1)
const _hoisted_71 = /*#__PURE__*/_createVNode("tr", null, [
  /*#__PURE__*/_createVNode("th", {
    rowspan: "2",
    class: "text-center"
  }, " 선택 "),
  /*#__PURE__*/_createVNode("th", {
    rowspan: "2",
    class: "text-center"
  }, " 종명 "),
  /*#__PURE__*/_createVNode("th", {
    colspan: "2",
    class: "text-center"
  }, " 분석결과 ")
], -1)
const _hoisted_72 = /*#__PURE__*/_createVNode("tr", null, [
  /*#__PURE__*/_createVNode("th", { class: "text-center" }, " 요오드 "),
  /*#__PURE__*/_createVNode("th", { class: "text-center" }, " 세슘 ")
], -1)
const _hoisted_73 = {
  class: "text-center",
  style: {"width":"50px","vertical-align":"middle"}
}
const _hoisted_74 = {
  class: "modal-footer text-center",
  style: {"display":"block"}
}
const _hoisted_75 = {
  class: "modal-footer text-center",
  style: {"display":"block"}
}
const _hoisted_76 = {
  class: "modal-dialog modal-lg",
  role: "document"
}
const _hoisted_77 = { class: "modal-content" }
const _hoisted_78 = { class: "modal-header" }
const _hoisted_79 = /*#__PURE__*/_createVNode("h5", {
  class: "modal-title",
  id: "exampleModalLabel"
}, "패류독소", -1)
const _hoisted_80 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_81 = { class: "modal-body" }
const _hoisted_82 = { class: "table table-responsive-sm table-bordered table-sm text-center" }
const _hoisted_83 = { colspan: "4" }
const _hoisted_84 = { class: "row justify-content-md-center align-items-center" }
const _hoisted_85 = /*#__PURE__*/_createVNode("div", { class: "col-3 text-center" }, " 패류독소 ", -1)
const _hoisted_86 = /*#__PURE__*/_createVNode("div", { class: "col-3 text-center" }, " 시료 채취일 및 기간 ", -1)
const _hoisted_87 = { class: "col-3" }
const _hoisted_88 = { class: "col-3" }
const _hoisted_89 = /*#__PURE__*/_createVNode("tr", null, [
  /*#__PURE__*/_createVNode("th", {
    colspan: "4",
    class: "text-center"
  }, " 패류채취 금지해역 ")
], -1)
const _hoisted_90 = {
  colspan: "4",
  class: "text-center"
}
const _hoisted_91 = { class: "form-check form-check-inline" }
const _hoisted_92 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "area1"
}, " 없음 ", -1)
const _hoisted_93 = { class: "form-check form-check-inline" }
const _hoisted_94 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "area2"
}, " 있음 ", -1)
const _hoisted_95 = /*#__PURE__*/_createVNode("tr", null, [
  /*#__PURE__*/_createVNode("th", { class: "text-center" }, " 선택 "),
  /*#__PURE__*/_createVNode("th", { class: "text-center" }, " 패류채취 금지해역 ")
], -1)
const _hoisted_96 = {
  class: "text-center",
  style: {"width":"50px","vertical-align":"middle"}
}
const _hoisted_97 = {
  class: "modal-footer text-center",
  style: {"display":"block"}
}
const _hoisted_98 = {
  class: "modal-footer text-center",
  style: {"display":"block"}
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", {
        class: ["card", { loading: _ctx.loading }]
      }, [
        _createVNode("ul", _hoisted_3, [
          _createVNode("li", _hoisted_4, [
            _createVNode("a", {
              class: "nav-link active",
              ref: "radiationBtn",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.switchTab($event, '방사능')))
            }, "방사능", 512)
          ]),
          _createVNode("li", _hoisted_5, [
            _createVNode("a", {
              class: "nav-link",
              ref: "shellfishBtn",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.switchTab($event, '패류독소')))
            }, "패류독소", 512)
          ])
        ]),
        _createVNode("div", _hoisted_6, [
          _createVNode("a", {
            class: "btn btn-primary mb-3",
            style: {"color":"white"},
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.openPopupRadiation && _ctx.openPopupRadiation(...args))),
            "data-target": "#exampleModal"
          }, [
            _hoisted_7,
            _hoisted_8
          ]),
          _createVNode("form", _hoisted_9, [
            _createVNode("div", _hoisted_10, [
              _createVNode("div", _hoisted_11, [
                _hoisted_12,
                _withDirectives(_createVNode("select", {
                  class: "form-control",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.filter.show = $event)),
                  required: ""
                }, [
                  _hoisted_13,
                  _hoisted_14,
                  _hoisted_15
                ], 512), [
                  [_vModelSelect, _ctx.filter.show]
                ])
              ]),
              _createVNode("div", _hoisted_16, [
                _createVNode("button", {
                  style: {"position":"absolute","bottom":"0"},
                  class: "btn btn-primary align-bottom",
                  type: "button",
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.searchHandler && _ctx.searchHandler(...args)))
                }, " 검색 ")
              ])
            ])
          ]),
          _createVNode("table", _hoisted_17, [
            _hoisted_18,
            _createVNode("tbody", null, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.radioactivities, (item) => {
                return (_openBlock(), _createBlock("tr", {
                  key: item.id,
                  onClick: ($event: any) => (_ctx.editRadio(item)),
                  class: "text-center"
                }, [
                  _createVNode("td", null, _toDisplayString(_ctx.dateTimeHelper.timestampToDate(
                      item.created_at._seconds,
                      'YYYY-MM-DD HH:mm',
                    )), 1),
                  _createVNode("td", null, _toDisplayString(item.start_analysis_date) + " - " + _toDisplayString(item.end_analysis_date), 1),
                  _createVNode("td", null, _toDisplayString(item.analysis_target), 1),
                  (
                    item.analysis_results && item.analysis_results.length > 1
                  )
                    ? (_openBlock(), _createBlock("td", _hoisted_19, _toDisplayString(item.analysis_results[0].fish_name) + " 외 " + _toDisplayString(item.analysis_results.length - 1) + " 종 ", 1))
                    : (_openBlock(), _createBlock("td", _hoisted_20, _toDisplayString(item.analysis_results[0].fish_name), 1)),
                  _createVNode("td", null, [
                    (item.detection_state === '검출')
                      ? (_openBlock(), _createBlock("span", _hoisted_21, "검출"))
                      : (item.detection_state === '불검출')
                        ? (_openBlock(), _createBlock("span", _hoisted_22, "불검출"))
                        : (_openBlock(), _createBlock("span", _hoisted_23, "미량검출"))
                  ])
                ], 8, ["onClick"]))
              }), 128))
            ])
          ]),
          _createVNode("div", _hoisted_24, [
            _createVNode("button", {
              class: "btn paging-prev",
              disabled: _ctx.currentRadioPage === 1,
              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.prevRadioPage && _ctx.prevRadioPage(...args)))
            }, " 이전 ", 8, ["disabled"]),
            _createVNode("button", {
              class: "btn paging-next",
              disabled: _ctx.radioactivities.length === 0,
              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.nextRadioPage && _ctx.nextRadioPage(...args)))
            }, " 다음 ", 8, ["disabled"])
          ])
        ], 512),
        _createVNode("div", _hoisted_25, [
          _createVNode("div", _hoisted_26, [
            _createVNode("a", {
              class: "btn btn-primary mb-3",
              style: {"color":"white"},
              onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.openPopupShellfish && _ctx.openPopupShellfish(...args)))
            }, [
              _hoisted_27,
              _hoisted_28
            ]),
            _createVNode("form", _hoisted_29, [
              _createVNode("div", _hoisted_30, [
                _createVNode("div", _hoisted_31, [
                  _hoisted_32,
                  _withDirectives(_createVNode("select", {
                    class: "form-control",
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.filter.show = $event)),
                    required: ""
                  }, [
                    _hoisted_33,
                    _hoisted_34,
                    _hoisted_35
                  ], 512), [
                    [_vModelSelect, _ctx.filter.show]
                  ])
                ]),
                _createVNode("div", _hoisted_36, [
                  _createVNode("button", {
                    style: {"position":"absolute","bottom":"0"},
                    class: "btn btn-primary align-bottom",
                    type: "button",
                    onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.searchHandler && _ctx.searchHandler(...args)))
                  }, " 검색 ")
                ])
              ])
            ]),
            _createVNode("table", _hoisted_37, [
              _hoisted_38,
              _createVNode("tbody", null, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.shellfishToxins, (item) => {
                  return (_openBlock(), _createBlock("tr", {
                    key: item.id,
                    onClick: ($event: any) => (_ctx.editShellfishToxins(item)),
                    class: "text-center"
                  }, [
                    _createVNode("td", null, _toDisplayString(_ctx.dateTimeHelper.timestampToDate(
                        item.created_at._seconds,
                        'YYYY-MM-DD HH:mm',
                      )), 1),
                    _createVNode("td", null, _toDisplayString(item.start_sampling_date) + " - " + _toDisplayString(item.end_sampling_date), 1),
                    _createVNode("td", null, [
                      (item.ban_areas?.length > 0)
                        ? (_openBlock(), _createBlock("span", _hoisted_39, "있음(" + _toDisplayString(item.ban_areas?.length) + ")", 1))
                        : (_openBlock(), _createBlock("span", _hoisted_40, "없음"))
                    ])
                  ], 8, ["onClick"]))
                }), 128))
              ])
            ]),
            _createVNode("div", _hoisted_41, [
              _createVNode("button", {
                class: "btn paging-prev",
                disabled: _ctx.currentRadioPage === 1,
                onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.prevShellfishPage && _ctx.prevShellfishPage(...args)))
              }, " prev ", 8, ["disabled"]),
              _createVNode("button", {
                class: "btn paging-next",
                disabled: _ctx.radioactivities.length === 0,
                onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.nextShellfishPage && _ctx.nextShellfishPage(...args)))
              }, " next ", 8, ["disabled"])
            ])
          ], 512)
        ], 512)
      ], 2)
    ]),
    _createVNode("div", {
      class: "modal modal_background fade show",
      id: "radiationModal",
      tabindex: "-1",
      role: "dialog",
      "aria-labelledby": "exampleModalLabel",
      "aria-hidden": "true",
      onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.closePopupRadiation($event, false)))
    }, [
      _createVNode("div", _hoisted_42, [
        _createVNode("div", _hoisted_43, [
          _createVNode("div", _hoisted_44, [
            _hoisted_45,
            _createVNode("button", {
              type: "button",
              class: "close",
              "data-dismiss": "modal",
              "aria-label": "Close",
              onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.closePopupRadiation($event, true)))
            }, [
              _hoisted_46
            ])
          ]),
          _createVNode("div", _hoisted_47, [
            _createVNode("table", _hoisted_48, [
              _createVNode("tbody", null, [
                _createVNode("tr", null, [
                  _createVNode("td", _hoisted_49, [
                    _createVNode("div", _hoisted_50, [
                      _hoisted_51,
                      _hoisted_52,
                      _createVNode("div", _hoisted_53, [
                        _withDirectives(_createVNode("input", {
                          class: "form-control",
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.radioactivityData.start_analysis_date = $event)),
                          type: "date",
                          required: ""
                        }, null, 512), [
                          [_vModelText, _ctx.radioactivityData.start_analysis_date]
                        ])
                      ]),
                      _createVNode("div", _hoisted_54, [
                        _withDirectives(_createVNode("input", {
                          class: "form-control",
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.radioactivityData.end_analysis_date = $event)),
                          type: "date",
                          required: ""
                        }, null, 512), [
                          [_vModelText, _ctx.radioactivityData.end_analysis_date]
                        ])
                      ])
                    ])
                  ])
                ]),
                _hoisted_55,
                _createVNode("tr", null, [
                  _createVNode("td", _hoisted_56, [
                    _createVNode("div", _hoisted_57, [
                      _withDirectives(_createVNode("input", {
                        class: "form-check-input",
                        type: "radio",
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.radioactivityData.analysis_target = $event)),
                        id: "target1",
                        value: "국내산"
                      }, null, 512), [
                        [_vModelRadio, _ctx.radioactivityData.analysis_target]
                      ]),
                      _hoisted_58
                    ]),
                    _createVNode("div", _hoisted_59, [
                      _withDirectives(_createVNode("input", {
                        class: "form-check-input",
                        type: "radio",
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.radioactivityData.analysis_target = $event)),
                        id: "target2",
                        value: "외국산"
                      }, null, 512), [
                        [_vModelRadio, _ctx.radioactivityData.analysis_target]
                      ]),
                      _hoisted_60
                    ]),
                    _createVNode("div", _hoisted_61, [
                      _withDirectives(_createVNode("input", {
                        class: "form-check-input",
                        type: "radio",
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.radioactivityData.analysis_target = $event)),
                        id: "target3",
                        value: "국내산 & 외국산"
                      }, null, 512), [
                        [_vModelRadio, _ctx.radioactivityData.analysis_target]
                      ]),
                      _hoisted_62
                    ])
                  ])
                ]),
                _hoisted_63,
                _createVNode("tr", null, [
                  _createVNode("td", _hoisted_64, [
                    _createVNode("div", _hoisted_65, [
                      _withDirectives(_createVNode("input", {
                        class: "form-check-input",
                        type: "radio",
                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.radioactivityData.detection_state = $event)),
                        id: "state1",
                        value: "불검출"
                      }, null, 512), [
                        [_vModelRadio, _ctx.radioactivityData.detection_state]
                      ]),
                      _hoisted_66
                    ]),
                    _createVNode("div", _hoisted_67, [
                      _withDirectives(_createVNode("input", {
                        class: "form-check-input",
                        type: "radio",
                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.radioactivityData.detection_state = $event)),
                        id: "state2",
                        value: "미량검출"
                      }, null, 512), [
                        [_vModelRadio, _ctx.radioactivityData.detection_state]
                      ]),
                      _hoisted_68
                    ]),
                    _createVNode("div", _hoisted_69, [
                      _withDirectives(_createVNode("input", {
                        class: "form-check-input",
                        type: "radio",
                        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_ctx.radioactivityData.detection_state = $event)),
                        id: "state3",
                        value: "검출"
                      }, null, 512), [
                        [_vModelRadio, _ctx.radioactivityData.detection_state]
                      ]),
                      _hoisted_70
                    ])
                  ])
                ]),
                _hoisted_71,
                _hoisted_72,
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.radiationList, (radiation, index) => {
                  return (_openBlock(), _createBlock("tr", {
                    key: radiation + index
                  }, [
                    _createVNode("td", _hoisted_73, [
                      _withDirectives(_createVNode("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": ($event: any) => (radiation.isChecked = $event)
                      }, null, 8, ["onUpdate:modelValue"]), [
                        [_vModelCheckbox, radiation.isChecked]
                      ])
                    ]),
                    _createVNode("td", null, [
                      _withDirectives(_createVNode("input", {
                        class: "form-control",
                        "onUpdate:modelValue": ($event: any) => (radiation.fish_name = $event),
                        type: "text"
                      }, null, 8, ["onUpdate:modelValue"]), [
                        [_vModelText, radiation.fish_name]
                      ])
                    ]),
                    _createVNode("td", null, [
                      _withDirectives(_createVNode("input", {
                        class: "form-control text-right",
                        "onUpdate:modelValue": ($event: any) => (radiation.iodine = $event),
                        type: "number",
                        step: "0.01"
                      }, null, 8, ["onUpdate:modelValue"]), [
                        [_vModelText, radiation.iodine]
                      ])
                    ]),
                    _createVNode("td", null, [
                      _withDirectives(_createVNode("input", {
                        class: "form-control text-right",
                        "onUpdate:modelValue": ($event: any) => (radiation.cesium = $event),
                        type: "number",
                        step: "0.01"
                      }, null, 8, ["onUpdate:modelValue"]), [
                        [_vModelText, radiation.cesium]
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ])
          ]),
          _createVNode("div", _hoisted_74, [
            _createVNode("button", {
              type: "button",
              class: "btn btn-secondary",
              onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.addRadiation && _ctx.addRadiation(...args)))
            }, " +행추가 "),
            _createVNode("button", {
              type: "button",
              class: "btn btn-secondary",
              onClick: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.removeRadiation && _ctx.removeRadiation(...args)))
            }, " x행삭제 ")
          ]),
          _createVNode("div", _hoisted_75, [
            _createVNode("button", {
              type: "button",
              class: "btn btn-primary",
              onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.submitRadioData && _ctx.submitRadioData(...args)))
            }, " 등록 "),
            _createVNode("button", {
              type: "button",
              class: "btn btn-secondary",
              "data-dismiss": "modal",
              onClick: _cache[25] || (_cache[25] = _withModifiers(($event: any) => (_ctx.closePopupRadiation($event, true)), ["prevent","stop"]))
            }, " 취소 ")
          ])
        ])
      ])
    ]),
    _createVNode("div", {
      class: "modal modal_background fade show",
      id: "shellfishModal",
      tabindex: "-1",
      role: "dialog",
      "aria-labelledby": "exampleModalLabel",
      "aria-hidden": "true",
      onClick: _cache[36] || (_cache[36] = ($event: any) => (_ctx.closePopupShellfish($event, false)))
    }, [
      _createVNode("div", _hoisted_76, [
        _createVNode("div", _hoisted_77, [
          _createVNode("div", _hoisted_78, [
            _hoisted_79,
            _createVNode("button", {
              type: "button",
              class: "close",
              "data-dismiss": "modal",
              "aria-label": "Close",
              onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.closePopupShellfish($event, true)))
            }, [
              _hoisted_80
            ])
          ]),
          _createVNode("div", _hoisted_81, [
            _createVNode("table", _hoisted_82, [
              _createVNode("tbody", null, [
                _createVNode("tr", null, [
                  _createVNode("td", _hoisted_83, [
                    _createVNode("div", _hoisted_84, [
                      _hoisted_85,
                      _hoisted_86,
                      _createVNode("div", _hoisted_87, [
                        _withDirectives(_createVNode("input", {
                          class: "form-control",
                          "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => (_ctx.shellfishToxinData.start_sampling_date = $event)),
                          type: "date",
                          required: ""
                        }, null, 512), [
                          [_vModelText, _ctx.shellfishToxinData.start_sampling_date]
                        ])
                      ]),
                      _createVNode("div", _hoisted_88, [
                        _withDirectives(_createVNode("input", {
                          class: "form-control",
                          "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => (_ctx.shellfishToxinData.end_sampling_date = $event)),
                          type: "date",
                          required: ""
                        }, null, 512), [
                          [_vModelText, _ctx.shellfishToxinData.end_sampling_date]
                        ])
                      ])
                    ])
                  ])
                ]),
                _hoisted_89,
                _createVNode("tr", null, [
                  _createVNode("td", _hoisted_90, [
                    _createVNode("div", _hoisted_91, [
                      _withDirectives(_createVNode("input", {
                        class: "form-check-input",
                        type: "radio",
                        "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => (_ctx.shellfishToxinData.hasBan = $event)),
                        id: "area1",
                        value: "없음"
                      }, null, 512), [
                        [_vModelRadio, _ctx.shellfishToxinData.hasBan]
                      ]),
                      _hoisted_92
                    ]),
                    _createVNode("div", _hoisted_93, [
                      _withDirectives(_createVNode("input", {
                        class: "form-check-input",
                        type: "radio",
                        "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => (_ctx.shellfishToxinData.hasBan = $event)),
                        id: "area2",
                        value: "있음"
                      }, null, 512), [
                        [_vModelRadio, _ctx.shellfishToxinData.hasBan]
                      ]),
                      _hoisted_94
                    ])
                  ])
                ]),
                (_ctx.shellfishToxinData.hasBan === '있음')
                  ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                      _hoisted_95,
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.banAreaList, (banArea) => {
                        return (_openBlock(), _createBlock("tr", { key: banArea }, [
                          _createVNode("td", _hoisted_96, [
                            _withDirectives(_createVNode("input", {
                              type: "checkbox",
                              "onUpdate:modelValue": ($event: any) => (banArea.isChecked = $event)
                            }, null, 8, ["onUpdate:modelValue"]), [
                              [_vModelCheckbox, banArea.isChecked]
                            ])
                          ]),
                          _createVNode("td", null, [
                            _withDirectives(_createVNode("input", {
                              class: "form-control",
                              "onUpdate:modelValue": ($event: any) => (banArea.area = $event),
                              type: "text"
                            }, null, 8, ["onUpdate:modelValue"]), [
                              [_vModelText, banArea.area]
                            ])
                          ])
                        ]))
                      }), 128))
                    ], 64))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createVNode("div", _hoisted_97, [
            _createVNode("button", {
              type: "button",
              class: "btn btn-secondary",
              onClick: _cache[32] || (_cache[32] = 
//@ts-ignore
(...args) => (_ctx.addBanArea && _ctx.addBanArea(...args)))
            }, " +행추가 "),
            _createVNode("button", {
              type: "button",
              class: "btn btn-secondary",
              onClick: _cache[33] || (_cache[33] = 
//@ts-ignore
(...args) => (_ctx.removeBanArea && _ctx.removeBanArea(...args)))
            }, " x행삭제 ")
          ]),
          _createVNode("div", _hoisted_98, [
            _createVNode("button", {
              type: "button",
              class: "btn btn-primary",
              onClick: _cache[34] || (_cache[34] = 
//@ts-ignore
(...args) => (_ctx.submitShellfishData && _ctx.submitShellfishData(...args)))
            }, " 등록 "),
            _createVNode("button", {
              type: "button",
              class: "btn btn-secondary",
              "data-dismiss": "modal",
              onClick: _cache[35] || (_cache[35] = _withModifiers(($event: any) => (_ctx.closePopupShellfish($event, true)), ["prevent","stop"]))
            }, " 취소 ")
          ])
        ])
      ])
    ])
  ], 512))
})